export const cardData = [{
    id: 1,
    image: './myimg/pngwing.com (1).png',
    header: 'FIRST RESPONDER',
    text: "When you're first on the scene, your gear can make all the difference. Combat Inventory products are made with durable materials and are packed with tactical features, providing you peace of mind even in the most hectic of situations."
},
{   
    image: './myimg/PngItem_1466766.png',
    header: 'CAMPING',
    text: 'We build everything with high-quality materials, handles, zippers, and compartments. Our products are made to handle the most demanding tasks.' 
},
{  
    id: 3,
    image: './myimg/PngItem_341548.png',
    header: 'HUNTING',
    text: 'Our packs and bags are perfect for day hunts. Our gear features waist straps to lessen the strain on your back, large storage areas to keep all of your gear organized and accessible, durable weather resistant materials to protect your supplies from the elements.' 
}]